/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import { v4 as uuid } from 'uuid';
import SimpleReactValidator from 'simple-react-validator';
import { Button, FormGroup, TextInput, Loading, TextArea } from 'carbon-components-react';
import Close16 from '@carbon/icons-react/lib/close/16';
import PropTypes from 'prop-types';
import { api, inspection } from '../../../../helpers/api/api'; //RITM1407400
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import {
  getError,
  entitiesLabels,
} from '../../../../helpers/Constants';

export default class CheckListRequirement extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.saveRequirement = this.saveRequirement.bind(this);
    this.renderLoadingModal = this.renderLoadingModal.bind(this);
    this.onCodeTextChange = this.onCodeTextChange.bind(this);
    this.onQuestionTextChange = this.onQuestionTextChange.bind(this);
    this.validator = new SimpleReactValidator();
    this.state = {
      newRequirement: {
        id: this.props.Requirement?.id || uuid(),
        code: this.props.Requirement?.code || null,
        name: this.props.Requirement?.name || null,
        createdBy: this.props.Requirement?.createdBy || null,
        createdOn: this.props.Requirement?.createdOn || null,
        updatedBy: this.props.Requirement?.updatedBy || null,
        updatedOn: this.props.Requirement?.updatedOn || null,
        description: this.props.Requirement?.description || null,
      },
      isUpdating: false,
    };
  }

  onCodeTextChange(event) {
    const { value } = event.currentTarget;
    // event.preventDefault();
    this.setState((prevState) => {
      const newRequirement = { ...prevState.newRequirement };
      newRequirement.code = value;
      return { newRequirement };
    });
  }

  onQuestionTextChange(event) {
    const { value } = event.currentTarget;
    // event.preventDefault();
    this.setState((prevState) => {
      const newRequirement = { ...prevState.newRequirement };
      newRequirement.name = value;
      return { newRequirement };
    });
  }

  renderLoadingModal = () => {
    const show = this.state.isUpdating;
    return show && <Loading active withOverlay description="Saving..." />;
  };

  saveRequirement = async (item) => {
    try {
      this.setState({ isUpdating: true });
      return (await api.post('/inspection/checklistquestion', item)).data;
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, 'Save Inspection', 'ERROR'));
      return null;
    } finally {
      this.setState({ isUpdating: false });
    }
  };

  updateRequirement = async (item) => {
    try {
      this.setState({ isUpdating: true });
      return (await api.put('/inspection/checklistquestion', item)).data;
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`,getError(error, 'Save Inspection', 'ERROR'));
      return null;
    } finally {
      this.setState({ isUpdating: false });
    }
  };

  //RITM1407400
  getInspection = async  (id) => {
    let _inspection = null;

    try {
      _inspection = (await inspection.get(id)).data;
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, 'Get Inspection', 'ERROR')
      );
    }
    return _inspection;
  };
  //End

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      // NEW
      if (!this.props.idCheckListAnswer) {
        const data = await this.getInspection(this.props.idInspection); //RITM1407400
        const newCheckListAnswer = {
          id: this.props.idCheckListAnswer || uuid(),
          idRequirement: this.state.newRequirement.id,
          idInspectionCheckList: this.props.CheckList.id,
          idInspectionCheckListTemplateSection: this.props.Section.id,
          idInspectionCheckListTemplate: this.props.Template.id,
          checkList: this.props.CheckList,
          template: this.props.Template,
          section: this.props.Section,
          requirement: this.state.newRequirement,
          active: data.inspectionReport.checkList.answers.filter(out => this.props.CheckList.id == out.idInspectionCheckList 
            && this.props.Template.id == out.idInspectionCheckListTemplate).some(c => c.active) ? true : false, //RITM1407400
        };
        const newItem = await this.saveRequirement(newCheckListAnswer);
        if (newItem) this.props.onSave(newItem);
      } else {
        const newItem = await this.updateRequirement(this.state.newRequirement);
        if (newItem) this.props.onUpdate(newItem);
      }
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,
        entitiesLabels.REQUIREMENT + 'r equired fields are missing'
      );
      this.forceUpdate();
    }
  };

  render() {
    const validations = {
      code: this.validator.message('code', this.state.newRequirement.code, 'required'),
      question: this.validator.message('question', this.state.newRequirement.name, 'required'),
    };
    return (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading"> Requirement Details</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              iconDescription="Close"
              onClick={this.props.onCancel}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row">
              <div className="bx--col-lg-6 bx--col-md-12">
                <FormGroup legendText="Code">
                  <TextInput
                    id="inputCode"
                    name="inputCode"
                    invalid={false}
                    invalidText="required"
                    labelText=""
                    value={this.state.newRequirement.code || ''}
                    onChange={this.onCodeTextChange}
                  />
                  {validations.code}
                </FormGroup>
              </div>
            </div>
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12">
                <FormGroup legendText="Question">
                  <TextArea
                    maxLength={5000}
                    labelText=""
                    id="inputQuestion"
                    name="inputQuestion"
                    cols={100}
                    disabled={false}
                    invalid={false}
                    invalidText="required"
                    light={false}
                    placeholder=""
                    rows={4}
                    value={this.state.newRequirement.name || ''}
                    onChange={(question) => this.onQuestionTextChange(question)}
                  />
                  {validations.question}
                </FormGroup>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button className="button--max-width" kind="secondary" onClick={this.props.onCancel}>
              Cancel
            </Button>

            <Button className="button--max-width" kind="primary" onClick={this.handleSubmit}>
              Save
            </Button>
          </div>
        </div>
        {this.renderLoadingModal()}
      </div>
    );
  }
}
CheckListRequirement.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  onUpdate: PropTypes.func,
  CheckList: PropTypes.object.isRequired,
  Section: PropTypes.object.isRequired,
  Template: PropTypes.object.isRequired,
  idCheckListAnswer: PropTypes.string,
  Requirement: PropTypes.object,
};
CheckListRequirement.defaultProps = {
  Requirement: null,
  idCheckListAnswer: null,
  onUpdate: () => {},
  onSave: () => {},
};
